// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";
import { closeSessionGlobal } from "../commons/utils";


const http = new AxiosAdapter();




export const createCategoriaCotizacionServicioService = async(data:object, percentaje:any) => {
   
    try {
        
        return await http.post<any>('/v1/quotation-category', data, percentaje); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('createCategoriaCotizacionServicioService ',error);

    }
}